"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitQuestionNode = void 0;
const visitQuestionNode = (parent, visitor) => {
    var _a;
    if (parent.root && visitor(parent, null) === 'STOP')
        return 'STOP';
    for (let i = 0; i < ((_a = parent.subQuestions) === null || _a === void 0 ? void 0 : _a.length); i++) {
        const x = parent.subQuestions[i];
        const shouldStop = visitor(x, parent) === 'STOP' || (0, exports.visitQuestionNode)(x, visitor) === 'STOP';
        if (shouldStop) {
            return 'STOP';
        }
    }
};
exports.visitQuestionNode = visitQuestionNode;
exports.default = exports.visitQuestionNode;
